<template lang="pug">
#system-error(v-cloak)
  #pc.d-flex.align-items-center.justify-content-center(v-if="appmode == 'pc'")
    .box.box-margin
      .box-body.p-4
        p.message.mb-4 予期せぬエラーが発生しました
        p ご不便をおかけして申し訳ありません。
        p 再ログインしてもエラーが発生する場合は、以下までご連絡ください。
        button.btn.btn-default-style.logout-btn(@click="logout()") ログイン画面へ
      .box-footer.p-4
        p － 本サービスに関する連絡先 －
        p {{ companyName }} {{ groupName }}
        p(v-if="name") 担当者名：{{ name }}
        p(v-if="tel") Tel：{{ tel }}
        p.mb-0(v-if="mail") 担当者連絡先：{{ mail }}

  #mobile(v-if="appmode == 'mobile'")
    .p-4
      p.title.mb-4 予期せぬエラーが発生しました
      p.mb-1 ご不便をおかけして申し訳ありません。
      p 再ログインしてもエラーが発生する場合は、以下までご連絡ください。
      button.btn.btn-default-style.logout-btn(@click="logout()") ログイン画面へ
    .pt-0.pr-4.pb-0.pl-4
      p.mb-2.contact － 本サービスに関する連絡先 －
      p.mb-1 {{ companyName }} {{ groupName }}
      p.mb-1(v-if="name") 担当者名：{{ name }}
      p.mb-1(v-if="tel") Tel：{{ tel }}
      p.mb-1(v-if="mail") 担当者連絡先：{{ mail }}
</template>

<script lang="ts">
import { Component, Vue } from "vue-property-decorator";
import { Getter } from "vuex-class";
import { userStore } from "@/store/store";

import Setting from "../../../public/setting.json";
import { Url } from "@/commons/constants/Url";

/**
 * ### システムエラー画面コンポーネント
 */
@Component
export default class SystemError extends Vue {
  /** アプリモード。storeのgetterから値を取得する */
  @Getter("appMode") appmode!: string;

  /** 会社名 */
  companyName: string = Setting.systemError.company;
  /** 部署 */
  groupName: string = Setting.systemError.group;
  /** 名前 */
  name: string = Setting.systemError.name;
  /** 電話番号 */
  tel: string = Setting.systemError.tel;
  /** メールアドレス */
  mail: string = Setting.systemError.mail;

  /**
   * ### vue lifecycle created
   *
   * storeのログアウト処理を呼び出し、セッション破棄を行う
   * セッション破棄を行うことで、戻るボタンを押下してもログイン画面へ遷移させることができる
   */
  public created(): void {
    userStore.logout();

    return;
  }

  /**
   * ### ログイン画面へ遷移する
   */
  public logout(): void {
    this.$router.push(Url.Root);

    return;
  }
}
</script>

<style lang="scss" scoped>
@import "../../styles/pc/_colors.scss";
@import "../../styles/pc/_mixin.scss";

#system-error {
  word-break: break-all;

  #pc {
    height: 100vh;
    width: 100vw;
    background-color: $bg-gray !important;

    .box {
      width: 520px;
      margin-left: auto;
      margin-right: auto;
      .box-body {
        .message {
          font-size: 1.55rem;
        }
        .logout-btn {
          min-width: 160px;
        }
      }
    }
  }

  #mobile {
    background-color: $bg-default !important;

    .title {
      color: rgba(51, 51, 51, 1);
      font-size: 1.4rem;
      font-weight: bold;
    }
  }
}
</style>
